import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import UnlockYourFullPotentialImage from './UnlockYourFullPotentialImage'

const copy = {
  heading: `Unlock your full potential`,
  description: `Our solutions make it easier to standardize and scale data governance across teams, businesses, and applications.`,
}

const UnlockYourFullPotential: FC = () => (
  <Wrapper>
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <UnlockYourFullPotentialImage />
      </Section.Contents>
    </SectionBase>
  </Wrapper>
)

const Wrapper = styled.div``

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default UnlockYourFullPotential
